module.exports = __webpack_public_path__ + "img/icon1.43f1517f.svg";